import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-cursor",
  "use": "icon-cursor-usage",
  "viewBox": "0 0 1000 1000",
  "content": "<symbol viewBox=\"0 0 1000 1000\" id=\"icon-cursor\"><path d=\"M950 33q-9 0-20 4L58 408q-24 10-25.5 27T53 465l361 113 119 369q12 21 29 21 8 0 15.5-6.5T590 943L963 71q7-18 3.5-28T950 33zM567 844L457 529l-314-95 731-308z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/cursor.svg
// module id = 1125
// module chunks = 2